import activityReducers from './activity.reducers';
import bankAccountReducers from './bank-account.reducers';
import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './ui.reducers';
import beneficiaryReducer from './beneficiary.reducers';
import translationReducers from './translation.reducers';
import balanceReducers from './balance.reducers';
import globalReducers from './global.reducers';
import userReducers from './user.reducers';
import convertReducers from './convert.reducers';
import requestsReducers from './requests.reducers';
import payReducers from './pay.reducers';
import contactReducers from './contact.reducers';
import settingsReducers from './settings.reducers';
import reportsReducers from './reports.reducers';
import notificationsReducer from './notifications.reducer';
import plansReducers from './plan.reducers';
import currencyRateReducer from './currency-rate.reducers';
import chatbotReducer from './chatbot.reducers';
import systemSettingsReducers from './system_settings.reducers';
import systemMessagesReducer from './system-messages.reducer';

const rootReducer = combineReducers({
	ui: uiReducer,
	beneficiary: beneficiaryReducer,
	translation: translationReducers,
	balance: balanceReducers,
	global: globalReducers,
	user: userReducers,
	bankAccount: bankAccountReducers,
	convert: convertReducers,
	pendingRequests: requestsReducers,
	pay: payReducers,
	contact: contactReducers,
	activity: activityReducers,
	settings: settingsReducers,
	reports: reportsReducers,
	notifications: notificationsReducer,
	plans: plansReducers,
	currencyRate: currencyRateReducer,
	chatbot: chatbotReducer,
	systemSettings: systemSettingsReducers,
	systemMessages: systemMessagesReducer,
});

export default rootReducer;
